import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ConditionalNavMarker = ({
  name,
  children
}) => name ? /*#__PURE__*/_jsx(NavMarker, {
  name: name,
  children: children
}) : /*#__PURE__*/_jsx(_Fragment, {
  children: children
});
export default ConditionalNavMarker;